"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAccordion = void 0;
const react_1 = __importStar(require("react"));
const react_animate_height_1 = __importDefault(require("react-animate-height"));
const classnames_template_literals_1 = __importDefault(require("@netlify/classnames-template-literals"));
const Button_1 = __importDefault(require("components/design-system/Button"));
const Divider_1 = __importDefault(require("components/design-system/Divider"));
const ConditionalWrapper_1 = __importDefault(require("components/shared/ConditionalWrapper"));
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
const AccordionContext = (0, react_1.createContext)(null);
const AccordionGroupContext = (0, react_1.createContext)(null);
const useAccordion = () => (0, react_1.useContext)(AccordionContext);
exports.useAccordion = useAccordion;
const useAccordionGroup = () => (0, react_1.useContext)(AccordionGroupContext);
const Accordion = ({ children, onChange, id = '', customClass, useBorder = false, withBorderOnExpand = true, contentOpen = false, dataCy, useBgColor = true }) => {
    const { accordionId, allowOpenAll } = useAccordionGroup() || {};
    const [isOpen, setIsOpen] = (0, react_1.useState)(contentOpen);
    let isAccordionOpen = false;
    if (allowOpenAll) {
        isAccordionOpen = isOpen;
    }
    else {
        isAccordionOpen = accordionId ? accordionId === id : isOpen;
    }
    const AccordionCN = (0, classnames_template_literals_1.default)(`
    ${useBgColor && 'bg-n-000'}
    ${customClass && customClass}
    ${useBorder && 'border-solid border rounded border-n-400'}
  `);
    return (react_1.default.createElement(AccordionContext.Provider, { value: {
            isOpen,
            setIsOpen,
            onChange,
            isAccordionOpen,
            id,
            withBorderOnExpand
        } },
        react_1.default.createElement("div", { className: AccordionCN, "data-cy": dataCy }, children)));
};
const Group = ({ children, useBorder = false, allowOpenAll = false }) => {
    const [accordionId, setAccordionId] = (0, react_1.useState)(null);
    return (react_1.default.createElement(AccordionGroupContext.Provider, { value: {
            accordionId,
            setAccordionId,
            allowOpenAll
        } },
        react_1.default.createElement("div", { className: `${useBorder ? 'border-solid border rounded border-n-400' : ''}` }, useBorder
            ? children.map((child, index) => (react_1.default.createElement(react_1.default.Fragment, null,
                child,
                children.length - 1 != index && (react_1.default.createElement("div", { className: "bg-n-400 h-[1px]" })))))
            : children)));
};
const Content = ({ children, customSpaceClass, customClass, useSeparator = false, useAnimateOnOpen = false }) => {
    const [childHeight, setChildHeight] = (0, react_1.useState)(0);
    const [showChild, setShowChild] = (0, react_1.useState)(false);
    const { isAccordionOpen } = (0, exports.useAccordion)() || {};
    const contentCN = (0, classnames_template_literals_1.default)(`
    ${customSpaceClass ? customSpaceClass : 'px-[24px] py-[24px]'}
    ${customClass && customClass}
    ${useSeparator ? 'border-n-400 border-solid border-0 border-t' : ''}
  `);
    (0, react_1.useEffect)(() => {
        if (useAnimateOnOpen) {
            if (isAccordionOpen && !showChild) {
                setShowChild(true);
                setTimeout(() => {
                    setChildHeight('auto');
                }, 50);
                return;
            }
            if (!isAccordionOpen && showChild) {
                setChildHeight(0);
                setTimeout(() => {
                    setShowChild(false);
                }, 600);
            }
        }
    }, [isAccordionOpen, showChild, useAnimateOnOpen]);
    return (react_1.default.createElement(ConditionalWrapper_1.default, { condition: useAnimateOnOpen, wrapper: (children) => (react_1.default.createElement(react_animate_height_1.default, { duration: 500, height: childHeight }, showChild && children)) }, useAnimateOnOpen ? (react_1.default.createElement("div", { className: contentCN }, children)) : (isAccordionOpen && react_1.default.createElement("div", { className: contentCN }, children))));
};
const Header = ({ children, customSpaceClass, dataCyChevronButton = '', useCustomHeader, useButtonSeparator, colorAccordion, customWrapperClass, useWrapperClick = true, customWrapperClick, additionalWrapperClick, subHeader }) => {
    const { setIsOpen, isOpen, onChange, isAccordionOpen, id } = (0, exports.useAccordion)() || {};
    const { accordionId, setAccordionId, allowOpenAll } = useAccordionGroup() || {};
    const handleClick = () => {
        if (allowOpenAll) {
            setIsOpen && setIsOpen(!isOpen);
        }
        else {
            if (id) {
                if (id === accordionId) {
                    setAccordionId && setAccordionId(null);
                }
                else {
                    setAccordionId && setAccordionId(id);
                }
                if (!accordionId) {
                    setIsOpen && setIsOpen(false);
                }
            }
            else {
                setIsOpen && setIsOpen(!isOpen);
            }
        }
        onChange && onChange({ isOpen });
        additionalWrapperClick && additionalWrapperClick();
    };
    const headerCN = (0, classnames_template_literals_1.default)(`
    ${customSpaceClass ? customSpaceClass : 'py-[24px] px-[24px]'}
    cursor-pointer
    flex
    justify-between
    items-center
  `);
    return (react_1.default.createElement("div", { className: `wrapper-header ${customWrapperClass ? customWrapperClass : ''}`, onClick: () => {
            useWrapperClick &&
                (customWrapperClick ? customWrapperClick() : handleClick());
        } },
        useCustomHeader ? (children) : (react_1.default.createElement("div", { className: headerCN },
            children,
            react_1.default.createElement("div", { className: "flex items-center" },
                useButtonSeparator && (react_1.default.createElement("div", { className: "h-[24px] ml-[24px]" },
                    react_1.default.createElement(Divider_1.default, { direction: "vertical", base: false }))),
                react_1.default.createElement("div", { className: "ml-[24px]" },
                    react_1.default.createElement(Button_1.default.Tertiary, { onClick: handleClick, customClass: "w-[36px] flex items-center justify-center", datacy: dataCyChevronButton },
                        react_1.default.createElement(SVGIcon_1.default, { size: 24, iconName: isAccordionOpen
                                ? 'icon-keyboard_arrow_up'
                                : 'icon-keyboard_arrow_down', fillColor: colorAccordion ? colorAccordion : 'var(--v-600)', customClass: "items-center" })))))),
        subHeader && subHeader));
};
Accordion.Group = Group;
Accordion.Header = Header;
Accordion.Content = Content;
exports.default = Accordion;
